import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialNoteTypeNotesState: Dtos.NoteTypeNotes & IRegistrationFormState = {
    noteTypeId: null,
    noteType: null,
    notes: [],
    saveAndReturn: null
}

export interface INoteTypeNotesReduxFormState {
    noteTypeId: IFieldState<number>,
    noteType: IFieldState<Dtos.NoteType>,
    notes: IFieldState<Dtos.Note[]>
}
